export let props = ['props', 'value', 'options','placeholder']
export let model = {}
export let computed = {
  // 默认将expandTrigger赋值为hover
  finalProps(){
    const p = {};
    Object.assign(p,this.props);
    p.expandTrigger = 'hover'
    return p;
  },
  currentValue: {
    // this.value 是一个对象或 undefined，这个对象是级联的一个节点
    get () {
      if (!this.value) return [undefined]
      let value = this.value[this.valueKey]
      let result = []
      let ok = false
      let level = 0
      /**
       * 深度搜索节点对应的路径
       * @param nodes 节点数组
       * @param val 节点的特征值
       * @param level 节点的深度（等级）
       */
      function findPath (nodes, val, level) {
        let len = nodes.length
        for (let i = 0; i < len; i++) {
          if (ok) break
          result.splice(level, result.length)
          let item = nodes[i]
          result.push(item[this.valueKey])
          if (item[this.valueKey] === val) {
            ok = true
            break
          } else if (item[this.childrenKey] && item[this.childrenKey].length > 0) {
            findPath.call(this, item[this.childrenKey], val, level + 1)
          }
        }
      }
      findPath.call(this, this.options, value, level)
      if (!ok) {
        result = []
      }
      // return ["2582cc8832194edea0699bc10fa50160"]
      return result
    },
    // val 是一个数组，我们需要的是数组的最后一个，然后通过这个值找到相应的节点，将节点传给父级
    set (val) {
      let value = val[val.length - 1]
      let result
      /**
       * 递归搜索节点的算法
       * @param nodes 节点数组
       * @param val 节点的特征值
       */
      function findNodeFromArray (nodes, val) {
        let len = nodes.length
        for (let i = 0; i < len; i++) {
          if (result) break
          let item = nodes[i]
          if (item[this.valueKey] === val) {
            result = item
            break
          } else if (item[this.childrenKey] && item[this.childrenKey].length > 0) {
            findNodeFromArray.call(this, item[this.childrenKey], val)
          }
        }
      }
      findNodeFromArray.call(this, this.options, value)
      this.$emit('input', result)
    }
  },
  valueKey () {
    if (this.props && this.props.value) {
      return this.props.value
    } else {
      return 'value'
    }
  },
  childrenKey () {
    if (this.props && this.props.children) {
      return this.props.children
    } else {
      return 'children'
    }
  }
}
